/**
 * 한국어 문구. 키는 `화면.항목` 꼴로 짓는다.
 *
 * 이 사전과 ja.ts 의 키 집합은 정확히 같아야 한다 — 테스트가 검사한다.
 */
export const ko: Record<string, string> = {
  "app.title": "통합 반품시스템",

  "nav.dashboard": "할 일",
  "nav.cases": "반품 목록",
  "nav.caseNew": "반품 접수",
  "nav.scan": "입고 스캔",
  "nav.orphans": "무적화물",
  "nav.shipments": "선적",
  "nav.itemMasters": "품목 마스터",
  "nav.settings": "내 계정",
  "nav.logout": "로그아웃",
  "nav.group.work": "처리",
  "nav.group.master": "기준 정보",
  "nav.group.help": "도움말",
  "nav.manual": "매뉴얼",
  "nav.group.account": "계정",
  "nav.menu": "메뉴",

  "search.title": "통합 검색",
  "search.placeholder": "주문번호·반송장·고객명 검색",
  "search.hint": "주문번호, 반송장번호, 고객명으로 찾습니다.",
  "search.empty": "찾는 반품 건이 없습니다.",
  "search.move": "이동",
  "search.open": "열기",
  "search.scope": "반품 건",

  "notify.title": "알림",
  "notify.empty": "새로운 알림이 없습니다.",
  "notify.readAll": "모두 읽음",
  "notify.unread": "안 읽은 알림 {count}건",
  "notify.kind.overdue": "접수 후 {days}일이 지나도록 입고되지 않은 건 {count}건",
  "notify.kind.review_requested": "항목을 다시 봐 달라는 요청 {count}건",
  "notify.kind.qty_mismatch": "검수 수량이 등록과 다른 건 {count}건",
  "notify.kind.doc_to_confirm": "서류 확인을 기다리는 건 {count}건",
  "notify.kind.kr_inbound_pending": "한국 입고를 기다리는 건 {count}건",

  "manual.title": "사용자 매뉴얼",
  "manual.description": "실제 화면의 메뉴·단추 이름 그대로 적어 두었습니다. 찾는 기능이 없으면 검색해 보세요.",
  "manual.toc": "목차",
  "manual.search": "매뉴얼 검색",
  "manual.searchPlaceholder": "예: 반품 등록, 인보이스, 반송장번호",
  "manual.results": "검색 결과 {count}건",
  "manual.noResults": "찾는 내용이 없습니다.",
  "manual.help": "이 화면 도움말",
  "manual.prev": "이전 문서",
  "manual.next": "다음 문서",

  "theme.toDark": "어둡게 보기",
  "theme.toLight": "밝게 보기",
  "nav.account": "계정",

  "login.title": "로그인",
  "login.id": "아이디",
  "login.password": "비밀번호",
  "login.submit": "로그인",
  "login.submitting": "확인 중…",

  "role.admin": "관리자",
  "role.shipper": "화주",
  "role.warehouse": "쿨트랙JP",

  "status.registered": "접수완료",
  "status.arrived": "입고완료",
  "status.documented": "서류완료",
  "status.shipped": "출고",
  "status.returned": "반송완료",
  "status.discarded": "폐기",
  "status.cancelled": "접수취소",

  "doc.pending": "미기재중",
  "doc.filled": "인보이스 항목기재",
  "doc.review_requested": "항목확인요청",
  "doc.confirmed": "확인완료",

  "shipment.draft": "준비",
  "shipment.shipped": "출고",
  "shipment.osaka_arrived": "오사카 도착",
  "shipment.sailed": "해상 운송중",
  "shipment.delivered": "반송완료",

  "reason.change_of_mind": "단순 변심",
  "reason.defect": "불량",
  "reason.wrong_item": "오배송",
  "reason.damaged": "파손",
  "reason.address_unknown": "주소불명",
  "reason.other": "기타",

  "disposition.return_kr": "한국반송",
  "disposition.discard": "폐기",
  "freight.collect": "착불",
  "freight.prepaid": "선불",
  "carrier.sagawa": "사가와",
  "carrier.yamato": "야마토",

  "card.arrived_today": "오늘 입고",
  "card.overdue": "미입고 경고",
  "card.doc_to_confirm": "서류 확인 대기",
  "card.ready_to_ship": "출고 대기",
  "card.arrival_to_confirm": "입고 확인 대기",
  "card.disposition_missing": "처리방안 미정",
  "card.items_missing": "인보이스 미기재",
  "card.review_requested": "항목확인요청",
  "card.kr_inbound_pending": "한국 입고 대기",
  "card.qty_mismatch": "수량 불일치",

  "dashboard.title": "지금 처리할 일",
  "dashboard.empty": "처리할 일이 없습니다.",
  "dashboard.unit": "건",
  "dashboard.description": "지금 손이 필요한 건을 모았습니다. 숫자를 누르면 그 목록으로 갑니다.",
  "dashboard.group.urgent": "지금 급한 일",
  "dashboard.group.mine": "내 차례",
  "dashboard.group.status": "현황",

  "case.seq": "No.",
  "case.receivedOn": "접수일",
  "case.orderNo": "주문번호",
  "case.trackingNo": "반송장번호",
  "case.carrier": "반입택배사",
  "case.customerName": "고객명",
  "case.customerPhone": "연락처",
  "case.returnReason": "반품사유",
  "case.arrivedOn": "반입일",
  "case.weight": "중량",
  "case.freight": "착/선불",
  "case.codFee": "착불비(JPY)",
  "case.disposition": "처리방안",
  "case.docStatus": "서류작성여부",
  "case.status": "상태",
  "case.closedOn": "한국반송/폐기일",
  "case.invoiceNo": "인보이스번호",
  "case.note": "비고",
  "case.org": "화주",
  "case.itemCount": "품목",

  "cases.title": "반품 목록",
  "cases.search": "주문번호·반송장·고객명 검색",
  "cases.filterStatus": "상태",
  "cases.filterAll": "전체",
  "cases.from": "접수일 시작",
  "cases.to": "접수일 끝",
  "cases.export": "CSV 내려받기",
  "cases.empty": "조건에 맞는 반품 건이 없습니다.",
  "cases.total": "총 {total}건",
  "cases.range": "총 {total}건 중 {from}–{to}건",
  "cases.sort": "정렬",
  "cases.pageSize": "페이지당 항목 수",
  "cases.perPage": "{count}개씩",
  "cases.prev": "이전",
  "cases.next": "다음",
  "cases.detail": "상세보기",
  "cases.clearFilter": "필터 지우기",
  "cases.period": "기간",
  "cases.periodToday": "오늘",
  "cases.period7d": "7일",
  "cases.period30d": "30일",
  "cases.periodCustom": "직접",
  "cases.clearAll": "조건 모두 지우기",

  "columns.title": "컬럼 설정",
  "columns.reset": "기본 칸으로",

  "views.title": "저장된 뷰",
  "views.save": "지금 조건 저장",
  "views.nameLabel": "뷰 이름",
  "views.remove": "뷰 삭제",
  "cases.emptyHint": "검색어나 기간을 바꿔 보세요.",

  "caseNew.title": "반품 접수",
  "caseNew.submit": "접수 등록",
  "caseNew.trackingHint": "아직 모르면 비워 둡니다.",
  "caseNew.orgPlaceholder": "화주를 고르세요",
  "caseNew.carrierPlaceholder": "택배사를 고르세요",
  "caseNew.done": "접수했습니다.",

  "caseDetail.title": "반품 상세",
  "caseDetail.intake": "접수 정보",
  "caseDetail.arrival": "입고 정보",
  "caseDetail.handling": "처리·확인",
  "caseDetail.items": "인보이스 품목",
  "caseDetail.shipment": "선적",
  "caseDetail.history": "이력",
  "caseDetail.edit": "수정",
  "caseDetail.save": "저장",
  "caseDetail.cancelEdit": "취소",
  "caseDetail.cancelCase": "접수 취소",
  "caseDetail.confirmArrival": "입고 내용 확인",
  "caseDetail.arriveManually": "손으로 입고 처리",
  "caseDetail.inspect": "검수 결과 저장",
  "caseDetail.inspectedAt": "검수",
  "caseDetail.inspectNote": "검수 메모",
  "caseDetail.setDisposition": "처리방안 정하기",
  "caseDetail.requestReview": "항목 확인요청",
  "caseDetail.confirmDoc": "서류 확정",
  "caseDetail.invoice": "인보이스 내려받기",
  "caseDetail.discard": "폐기 처리",
  "caseDetail.noShipment": "아직 선적에 실리지 않았습니다.",
  "caseDetail.reviewReason": "쿨트랙JP의 확인이 필요한 이유",
  "caseDetail.closedOn": "처리일",
  "caseDetail.tab.summary": "요약",
  "caseDetail.tab.items": "인보이스 품목",
  "caseDetail.tab.history": "이력",
  "caseDetail.nextActions": "지금 할 일",
  "caseDetail.nextActionsEmpty": "지금 이 건에서 할 수 있는 작업이 없습니다.",
  "caseDetail.owner.shipper": "화주가 할 일",
  "caseDetail.owner.warehouse": "쿨트랙JP가 할 일",
  // 담당 이름표 — "할 일" 이 아닌 자리(요약 카드·이력)에서 쓰는 짧은 이름(lib/case-owner.ts).
  "owner.shipper": "화주",
  "owner.warehouse": "쿨트랙JP",
  "owner.side.shipper": "한국 화주",
  "owner.side.warehouse": "일본 창고",
  "caseDetail.blockedReason": "막힌 이유",
  "caseDetail.terminal": "이 건은 종료되었습니다.",
  "caseDetail.historyEmpty": "아직 이력이 없습니다.",
  "caseDetail.step.registered": "접수",
  "caseDetail.step.arrived": "입고",
  "caseDetail.step.documented": "서류",
  "caseDetail.step.shipped": "출고",
  "caseDetail.step.returned": "완료",

  "lines.title": "반품 상품",
  "lines.hint": "무엇이 몇 개 돌아오는지 적습니다. 쿨트랙JP가 상자를 열어 이 수량과 맞춰 봅니다.",
  "lines.item": "상품",
  "lines.manual": "직접 입력",
  "lines.description": "상품명",
  "lines.descriptionHint": "목록에 없으면 여기에 적습니다.",
  "lines.qty": "반품수량",
  "lines.receivedQty": "검수수량",
  "lines.add": "줄 추가",
  "lines.remove": "줄 지우기",
  "lines.empty": "등록된 반품 상품이 없습니다(옛 건).",

  "items.add": "품목 추가",
  "items.remove": "삭제",
  "items.search": "품명·HS코드 검색",
  "items.qty": "수량",
  "items.unitPrice": "단가",
  "items.amount": "금액",
  "items.description": "품명(영문)",
  "items.hsCode": "HS코드",
  "items.origin": "원산지",
  "items.total": "합계",
  "items.save": "품목 저장",
  "items.empty": "기재된 품목이 없습니다.",
  "items.pickMaster": "품목 마스터에서 고르기",
  "items.manual": "직접 입력",
  "items.count": "{count}개",
  "items.masterResults": "검색 결과",

  "scan.title": "입고 스캔",
  "scan.prompt": "운송장 바코드를 찍으세요",
  "scan.input": "운송장번호",
  "scan.success": "입고 처리했습니다",
  "scan.weightPrompt": "중량을 입력하세요 (g)",
  "scan.saveWeight": "중량 저장",
  "scan.save": "저장",
  "scan.codFeeHint": "모르면 비워 둡니다.",
  "scan.skipWeight": "나중에",
  "scan.today": "오늘 스캔",
  "scan.orphanTitle": "무적화물",
  "scan.orphanDesc": "접수된 건이 없는데 창고에 들어온 상자입니다. 사가와·야마토 운송장만 모읍니다.",
  "scan.orphanNew": "접수된 건이 없어 무적화물로 등록했습니다 — {trackingNo}",
  "scan.orphanAgain": "이미 무적화물로 등록된 상자입니다 — {trackingNo}",
  "scan.orphanCount": "{count}번 찍힘",
  "orphan.linkTitle": "무적화물을 접수 건에 잇기",
  "orphan.linkHelp": "어느 건인지 고르면 그 건에 이 운송장번호를 채우고 입고완료로 올립니다. 반송장번호가 비어 있는 접수 건만 보입니다 — 번호가 틀리게 적혀 있으면 접수 화면에서 고친 뒤 상자를 다시 찍으세요.",
  "orphan.searchLabel": "접수 건 찾기",
  "orphan.searchPlaceholder": "주문번호 · 수취인",
  "orphan.link": "잇기",
  "orphan.linked": "{orderNo} 건에 이어 입고 처리했습니다",
  "orphan.noCandidates": "이을 수 있는 접수 건이 없습니다.",
  "orphan.noCandidatesHint": "반송장번호가 비어 있는 접수 건만 이을 수 있습니다. 아직 접수되지 않았다면 화주가 접수한 뒤에 이으세요.",
  "scan.orphanAll": "무적화물 전체",
  "orphans.title": "무적화물",
  "orphans.description": "접수된 건이 없는데 창고에 들어온 상자입니다. 입고 스캔 화면과 같은 목록이고, 잇기도 같습니다.",
  "orphans.count": "전체 {count}개",
  "orphans.search": "찾기",
  "orphans.searchPlaceholder": "운송장번호 · 주문번호 · 수취인",
  "orphans.trackingNo": "무적화물 송장번호",
  "orphans.linkState": "잇기 여부",
  "orphans.open": "미연결",
  "orphans.resolved": "연결됨",
  "orphans.carrierUnknown": "미확인",
  "orphans.lastSeenAt": "스캔 일시",
  "orphans.firstSeenAt": "처음 들어온 때",
  "orphans.firstSeenBy": "찍은 사람",
  "orphans.resolvedCase": "이은 접수 건",
  "orphans.caseStatus": "입고 상태",
  "orphans.resolvedAt": "이은 때",
  "orphans.action": "처리",
  "orphans.empty": "무적화물이 없습니다.",
  "orphans.emptyHint": "접수된 건이 없는 상자를 찍으면 여기에 쌓입니다. 일반 입고 화물은 여기 나오지 않습니다.",
  "scan.todayEmpty": "아직 스캔한 건이 없습니다.",
  "scan.freight": "착/선불",
  "scan.count": "오늘 {count}건",
  "scan.description": "바코드를 찍으면 바로 입고 처리하고 중량·착선불 입력으로 넘어갑니다.",
  "scan.app.download": "스캐너 앱 내려받기 ({size})",
  "scan.app.downloadNote": "내려받은 파일을 열어 설치합니다. 「출처를 알 수 없는 앱」 설치를 허용해 달라고 물으면 허용하세요. 설치 후 이 화면으로 돌아와 다시 누르면 앱이 열립니다.",
  "scan.app.downloadDebug": "지금 올라와 있는 것은 개발용 빌드라 파일이 큽니다.",
  "devices.pairPageTitle": "이 주소는 스캐너 앱이 읽는 것입니다",
  "devices.pairPageHint": "cooltrack 스캐너 앱의 카메라로 QR 을 비춰 주세요.",
  "devices.pairPageBody": "일반 QR 앱이나 브라우저로는 등록되지 않습니다. 설정 → 스캐너 기기에서 QR 을 다시 띄운 뒤, 앱을 열어 그 QR 을 비추면 됩니다.",
  "devices.pairPageBack": "스캐너 기기로 가기",
  "devices.title": "스캐너 기기",
  "devices.description": "창고 폰에 스캐너 앱을 깔고 여기서 만든 QR 을 한 번 읽히면, 앱이 바로 입고 등록을 합니다.",
  "devices.name": "기기 이름",
  "devices.namePlaceholder": "예: 창고 폰 1",
  "devices.add": "기기 등록",
  "devices.newTitle": "앱에서 이 QR 을 읽어 주세요",
  "devices.newHint": "앱을 열면 나오는 카메라로 아래 QR 을 비추면 등록이 끝납니다.",
  "devices.onceOnly": "이 QR 은 지금만 볼 수 있습니다. 닫으면 다시 볼 수 없으니, 못 읽었다면 기기를 다시 등록하세요.",
  "devices.qrAlt": "기기 등록용 QR 코드",
  "devices.empty": "등록된 기기가 없습니다.",
  "devices.lastUsed": "마지막 사용",
  "devices.revoke": "해제",
  "devices.revoked": "해제됨",
  "scan.camera.open": "카메라로 스캔",
  "scan.camera.manualLabel": "또는 운송장번호 직접 입력",
  "scan.camera.starting": "카메라를 켜는 중…",
  "scan.camera.aim": "바코드를 안내선 안에 맞추세요",
  "scan.camera.processing": "{code} 처리 중…",
  "scan.camera.next": "{code} 읽음 · 다음 바코드를 비추세요",
  "scan.camera.paused": "입력 중이라 스캔을 멈췄습니다",
  "scan.camera.rescan": "다시 스캔",
  "scan.camera.torch": "플래시",
  "scan.camera.close": "카메라 닫기",
  "scan.camera.resume": "카메라 다시 켜기",
  "scan.camera.retry": "다시 시도",
  "scan.camera.stoppedIdle": "한동안 쓰지 않아 카메라를 껐습니다.",
  "scan.camera.stoppedHidden": "화면을 벗어나 카메라를 껐습니다.",
  "scan.camera.focusHere": "탭한 자리에 초점 다시 맞추기",
  "scan.camera.slowHint": "바코드 전체가 안내선 안에 들어오게 하고, 흔들리지 않게 잡아 주세요. 흐리게 보이면 바코드를 화면에서 탭하면 그 자리에 초점을 다시 맞춥니다. 어두우면 플래시를 켜거나 번호를 직접 입력하세요.",
  "scan.camera.slowHintNoFocus": "이 기기는 초점을 조절할 수 없습니다. 바코드가 화면 가로를 절반 이상 채우도록 거리를 맞춰 보고, 그래도 흐리면 조금 떨어뜨려 주세요. 어두우면 플래시를 켜고, 계속 안 되면 번호를 직접 입력하세요.",
  "scan.camera.manualFallback": "아래 입력칸에 운송장번호를 직접 입력해도 입고 처리됩니다.",
  "scan.camera.error.permission": "카메라 권한이 거부되었습니다. 브라우저 설정에서 카메라를 허용하세요.",
  "scan.camera.error.notFound": "사용할 수 있는 카메라가 없습니다.",
  "scan.camera.error.inUse": "다른 앱이 카메라를 쓰고 있어 켜지 못했습니다.",
  "scan.camera.error.insecure": "보안 연결(https)에서만 카메라를 쓸 수 있습니다.",
  "scan.camera.error.unsupported": "이 브라우저는 카메라 스캔을 지원하지 않습니다.",
  "scan.camera.error.engine": "바코드 인식기를 불러오지 못했습니다. 네트워크를 확인하세요.",
  "scan.camera.error.unknown": "카메라를 켜지 못했습니다.",

  "shipments.title": "선적",
  "shipments.new": "선택한 건으로 선적 만들기",
  "shipments.no": "선적번호",
  "shipments.caseCount": "건수",
  "shipments.totalWeight": "총중량",
  "shipments.boxCount": "박스수",
  "shipments.shippedOn": "출고일",
  "shipments.seinoNo": "세이노번호",
  "shipments.osakaArrivedOn": "오사카 도착",
  "shipments.vesselOn": "항차",
  "shipments.panstarTracking": "팬스타 추적번호",
  "shipments.invoice": "인보이스 내려받기",
  "shipments.ship": "출고 처리",
  "shipments.osaka": "오사카 도착 기록",
  "shipments.departJp": "일본 출항 처리",
  "shipments.departJpHint": "팬스타 추적번호를 적으면 한국 도착을 기다리는 상태가 됩니다.",
  "shipments.arriveKr": "한국 입고 처리",
  "shipments.arriveKrHint": "한국 지정창고에 들어온 날을 적으면 포함된 반품 건이 모두 종결됩니다.",
  "shipments.arriveKrWaiting": "한국 도착을 기다리는 중입니다. 입고 확인은 한국 쪽 계정이 합니다.",
  "shipments.krArrivedOn": "한국 입고일",
  "shipments.empty": "선적이 없습니다.",
  "shipments.readyTitle": "출고 대기 중인 반품 건",
  "shipments.readyEmpty": "출고할 수 있는 건이 없습니다.",
  "shipments.cases": "포함된 반품 건",
  "shipments.selected": "{count}건 선택",
  "shipments.summary": "선적 정보",
  "shipments.step.draft": "준비",
  "shipments.step.shipped": "출고",
  "shipments.step.osaka_arrived": "오사카 도착",
  "shipments.step.sailed": "해상 운송",
  "shipments.step.delivered": "반송완료",

  "itemMasters.title": "품목 마스터",
  "itemMasters.code": "코드",
  "itemMasters.nameKo": "품명(한국어)",
  "itemMasters.nameEn": "품명(영문)",
  "itemMasters.hsCode": "HS코드",
  "itemMasters.origin": "원산지",
  "itemMasters.originHint": "고른 값이 인보이스에 그대로 실립니다.",
  "origin.KOREA": "한국(KOREA)",
  "origin.CHINA": "중국(CHINA)",
  "origin.JAPAN": "일본(JAPAN)",
  "itemMasters.price": "기본 단가",
  "itemMasters.active": "사용",
  "itemMasters.add": "품목 추가",
  "itemMasters.edit": "수정",
  "itemMasters.editTitle": "품목 수정",
  "itemMasters.codeLocked": "코드는 품목을 가리키는 이름이라 바꾸지 않습니다.",
  "itemMasters.empty": "등록된 품목이 없습니다.",
  "itemMasters.org": "화주",
  "itemMasters.common": "공용",
  "itemMasters.inactive": "미사용",
  "itemMasters.searchTitle": "등록된 품목",

  "settings.title": "내 계정",
  "settings.account": "계정 정보",
  "settings.language": "화면 언어",
  "settings.languageKo": "한국어",
  "settings.languageJa": "일본어",
  "settings.name": "이름",
  "settings.id": "아이디",
  "settings.role": "역할",

  "settings.password": "비밀번호",
  "settings.passwordDesc": "주기적으로 바꾸면 계정이 더 안전합니다.",
  "settings.passwordAction": "비밀번호 변경",

  "password.title": "비밀번호 변경",
  "password.description": "현재 비밀번호를 확인한 뒤 새 비밀번호로 바꿉니다.",
  "password.formTitle": "비밀번호 입력",
  "password.current": "현재 비밀번호",
  "password.new": "새 비밀번호",
  "password.confirm": "새 비밀번호 확인",
  "password.hint": "{min}자 이상 입력하세요.",
  "password.submit": "비밀번호 변경",
  "password.submitting": "바꾸는 중…",
  "password.doneTitle": "비밀번호가 변경되었습니다.",
  "password.doneBody": "보안을 위해 모든 기기에서 로그아웃했습니다. 새 비밀번호로 다시 로그인해 주세요.",
  "password.doneLogin": "다시 로그인",

  "common.loading": "불러오는 중…",
  "common.save": "저장",
  "common.cancel": "취소",
  "common.close": "닫기",
  "common.confirm": "확인",
  "common.yes": "예",
  "common.no": "아니오",
  "common.none": "—",
  "common.required": "필수",
  "common.select": "선택",
  "common.retry": "다시 시도",
  "common.saved": "저장했습니다.",
  "common.edit": "수정",
  "common.done": "완료",
  "common.menu": "메뉴",
  "common.remove": "지우기",
  "common.back": "뒤로",
  "login.subtitle": "사내 계정으로 로그인하세요.",

  "blocker.DISPOSITION_REQUIRED": "처리방안을 먼저 정하세요.",
  "blocker.NO_INVOICE_ITEMS": "인보이스 품목을 먼저 기재하세요.",
  "blocker.NOT_INSPECTED": "쿨트랙JP의 검수가 아직 끝나지 않았습니다.",
  "blocker.REVIEW_PENDING": "항목 확인요청이 걸려 있습니다. 쿨트랙JP가 고쳐야 합니다.",
  "blocker.INVALID_STATUS_TRANSITION": "지금 단계에서는 할 수 없습니다.",
  "blocker.CASE_NOT_DOCUMENTED": "서류를 확정하면 인보이스를 뽑을 수 있습니다.",

  "error.UNAUTHORIZED": "로그인이 필요합니다.",
  "error.FORBIDDEN": "권한이 없습니다.",
  "error.NOT_FOUND": "찾을 수 없습니다.",
  "error.INTERNAL": "서버에 문제가 생겼습니다. 잠시 뒤 다시 시도하세요.",
  "error.VALIDATION_FAILED": "입력한 값을 다시 확인하세요.",
  "error.MALFORMED_JSON": "요청 형식이 잘못됐습니다.",
  "error.INVALID_CREDENTIALS": "아이디나 비밀번호가 맞지 않습니다.",
  "error.INVALID_CURRENT_PASSWORD": "현재 비밀번호가 맞지 않습니다.",
  "error.PASSWORD_TOO_SHORT": "비밀번호는 10자 이상이어야 합니다.",
  "error.PASSWORD_TOO_LONG": "비밀번호가 너무 깁니다.",
  "error.PASSWORD_CONFIRM_MISMATCH": "새 비밀번호와 확인이 서로 다릅니다.",
  "error.PASSWORD_SAME_AS_CURRENT": "현재 비밀번호와 다른 비밀번호를 입력하세요.",
  "error.CASE_NOT_FOUND": "해당 반품 건을 찾을 수 없습니다.",
  "error.ORG_REQUIRED": "화주를 골라야 합니다.",
  "error.TRACKING_NO_DUPLICATED": "이미 등록된 반송장번호입니다.",
  "error.TRACKING_NO_NOT_FOUND": "해당 운송장번호의 반품 건이 없습니다.",
  "error.TRACKING_NO_REQUIRED": "운송장번호를 입력하세요.",
  "error.TRACKING_NO_MISMATCH": "이 건에 적힌 반송장번호와 다릅니다.",
  "error.STALE_UPDATE": "다른 사람이 먼저 고쳤습니다. 최신 내용을 다시 불러옵니다.",
  "error.INTAKE_LOCKED": "입고된 뒤에는 접수 내용을 고칠 수 없습니다.",
  "error.NOTHING_TO_UPDATE": "바꿀 내용이 없습니다.",
  "error.INVALID_STATUS_TRANSITION": "지금 상태에서는 할 수 없는 처리입니다.",
  "error.ALREADY_ARRIVED": "이미 입고 처리된 건입니다.",
  "error.ORPHAN_NOT_FOUND": "그 무적화물 기록을 찾을 수 없습니다.",
  "error.ORPHAN_ALREADY_RESOLVED": "이미 다른 건에 이어진 상자입니다. 목록을 다시 불러옵니다.",
  "error.NOT_ARRIVED_YET": "아직 입고되지 않았습니다.",
  "error.COD_FEE_ON_PREPAID": "선불이면 착불비를 적지 않습니다.",
  "error.DISPOSITION_REQUIRED": "처리방안을 먼저 정하세요.",
  "error.NO_INVOICE_ITEMS": "인보이스 품목이 없습니다.",
  "error.NOT_INSPECTED": "검수를 먼저 마쳐야 합니다.",
  "error.NO_CASE_LINES": "이 건에는 반품 상품이 등록되어 있지 않습니다.",
  "error.CASE_LINE_NOT_FOUND": "그 줄을 찾을 수 없습니다.",
  "error.INSPECT_INCOMPLETE": "모든 줄의 수량을 적어야 검수가 끝납니다.",
  "error.LINE_DESCRIPTION_REQUIRED": "상품명을 적거나 품목을 고르세요.",
  "error.REVIEW_PENDING": "항목 확인요청이 걸려 있습니다.",
  "error.DISPOSITION_MISMATCH": "폐기로 정한 건만 폐기할 수 있습니다.",
  "error.ITEM_MASTER_NOT_FOUND": "그 품목을 쓸 수 없습니다.",
  "error.ITEM_DESCRIPTION_REQUIRED": "품명과 HS코드가 필요합니다.",
  "error.ITEM_CODE_DUPLICATED": "이미 있는 품목 코드입니다.",
  "error.MIXED_CURRENCY": "한 인보이스에 여러 통화를 섞을 수 없습니다.",
  "error.INVALID_AMOUNT": "금액 형식이 잘못됐습니다.",
  "error.INVALID_QUANTITY": "수량 형식이 잘못됐습니다.",
  "error.SHIPMENT_NOT_FOUND": "선적을 찾을 수 없습니다.",
  "error.NO_CASES_SELECTED": "반품 건을 하나 이상 고르세요.",
  "error.ALREADY_IN_SHIPMENT": "이미 다른 선적에 들어 있습니다.",
  "error.CASE_NOT_DOCUMENTED": "서류가 확정되지 않은 건이 있습니다.",
  "error.INVALID_SHIPMENT_TRANSITION": "지금 선적 상태에서는 할 수 없는 처리입니다.",
  "error.NETWORK": "서버에 연결하지 못했습니다.",

  "event.intake_created": "접수 등록",
  "event.intake_updated": "접수 내용 수정",
  "event.cancelled": "접수 취소",
  "event.scanned_in": "입고 스캔",
  "event.arrived_manually": "손 입고 처리",
  "event.orphan_linked": "무적화물에서 이어 입고",
  "event.weight_set": "중량 기록",
  "event.freight_set": "착/선불 기록",
  "event.inspected": "검수",
  "event.lines_replaced": "반품 상품 수정",
  "event.arrival_confirmed": "입고 내용 확인",
  "event.disposition_set": "처리방안 결정",
  "event.items_replaced": "인보이스 품목 기재",
  "event.review_requested": "항목 확인요청",
  "event.doc_confirmed": "서류 확정",
  "event.assigned_shipment": "선적 배정",
  "event.shipped": "출고",
  "event.osaka_arrived": "오사카 도착",
  "event.departed_jp": "일본 출항",
  "event.returned": "반송완료",
  "event.discarded": "폐기",
}
